<template>
	<div style="border: 1px solid #ccc;padding:15px;background-color: #f5f5f5;">
		
	</div>
</template>
<script>
	import Vue from 'vue'
	export default Vue.extend({
		components: {
			Editor,
			Toolbar
		},
		data() {},
		methods: {},
		mounted(){}
	})
</script>
<style scoped>
	.avatar-uploader .el-upload {
		border: 1px dashed #a5a5a5;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>